import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconRingGroup } from '../../../base/icons/svg';
import { AbstractSortParticipantsButton, _abstractMapStateToProps } from './AbstractSortParticipantsButton';
/**
 * A button which starts/stops the transcriptions.
 */
class SortParticipantsButton extends AbstractSortParticipantsButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.sortParticipants';
        this.icon = IconRingGroup;
        this.toggledIcon = IconRingGroup;
        this.tooltip = 'toolbar.sortParticipants';
        this.label = 'toolbar.sortParticipants';
    }
}
export default translate(connect(_abstractMapStateToProps)(SortParticipantsButton));
